
import React, { Component } from "react";
import logoImg from "../../assets/images/logo.png";
class DonorCard extends Component {
  constructor(props) {
    super(props);
    this.cardRef = React.createRef();
  }

  render() {
    const {
      fullName,
      donorId,
      age,
      bloodGroup,
      whatsapp,
      validity,
      issueDate,
      photoPreview,
    } = this.props;

    return (
      <div
        ref={this.cardRef}
        className="donor-card"
        style={{
          width: "100%",
          maxWidth: "700px",
          margin: "0 auto",
          background: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 6px 24px rgba(0,0,0,0.15)",
          overflow: "hidden",
          fontFamily: "'Segoe UI', Arial, sans-serif",
          position: "relative",
        }}
      >
        {/* Decorative background shapes */}
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: 220,
            height: 220,
            background:
              "linear-gradient(135deg, rgba(220,53,69,0.10) 0%, rgba(220,53,69,0) 60%)",
            clipPath: "polygon(100% 0, 100% 100%, 0 0)",
            pointerEvents: "none",
            zIndex: 0,
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "60%",
            height: 90,
            background:
              "linear-gradient(115deg, rgba(0,0,0,0.03) 25%, transparent 25.5%, transparent 50%, rgba(0,0,0,0.03) 50.5%, rgba(0,0,0,0.03) 75%, transparent 75.5%, transparent)",
            backgroundSize: "14px 14px",
            pointerEvents: "none",
            zIndex: 0,
          }}
        />
        <div
          style={{
            position: "absolute",
            top: -30,
            right: -30,
            width: 160,
            height: 160,
            borderRadius: "50%",
            background: "rgba(220,53,69,0.06)",
            pointerEvents: "none",
            zIndex: 0,
          }}
        />

        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px 28px 10px 28px",
            position: "relative",
            zIndex: 1,
          }}
        >
          <img
            src={logoImg}
            alt="AWT Logo"
            style={{
              width: 66,
              height: 66,
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #c99a3a",
              boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
            }}
          />
          <div style={{ textAlign: "right" }}>
            <h1 style={{ margin: 0, fontSize: "26px", fontWeight: 900 }}>
              <span style={{ color: "#1a1a1a" }}>LIFE SAVER</span>{" "}
              <span style={{ color: "#dc3545" }}>CARD</span>
            </h1>
            <p
              style={{
                margin: "2px 0 0 0",
                fontSize: "12px",
                color: "#dc3545",
                fontWeight: 600,
              }}
            >
              Every donation can save up to three lives
            </p>
          </div>
        </div>

        <div
          style={{
            height: 2,
            background: "linear-gradient(to right, #dc3545, transparent)",
            margin: "0 28px",
            position: "relative",
            zIndex: 1,
          }}
        />

        {/* Body */}
        <div
          style={{
            display: "flex",
            padding: "24px 28px 10px 28px",
            alignItems: "center",
            gap: 20,
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* Left: details */}
          <div style={{ flex: 1 }}>
            {[
              ["DONOR Name", fullName],
              ["DONOR ID", donorId],
              ["Age", age],
              ["Blood Group", bloodGroup],
              ...(whatsapp ? [["Phone Number", whatsapp]] : []),
              ["Validity", validity],
              ["Issue Date", issueDate],
            ].map(([label, value], i) => (
              <div
                key={i}
                style={{ display: "flex", marginBottom: 10, fontSize: 15 }}
              >
                <span style={{ width: 150, color: "#1a1a1a", fontWeight: 600 }}>
                  {label} :
                </span>
                <span
                  style={{
                    color:
                      label === "Blood Group" ||
                      label === "Validity" ||
                      label === "Phone Number" ||
                      label === "DONOR ID"
                        ? "#dc3545"
                        : "#444",
                    fontWeight: 600,
                  }}
                >
                  {value}
                </span>
              </div>
            ))}
          </div>

          {/* Right: photo */}

          {photoPreview && (
            <div
              style={{
                position: "relative",
                width: 180,
                height: 200,
                flexShrink: 0,
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: 170,
                  height: 190,
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: "4px solid #dc3545",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
                  background: "#eee",
                }}
              >
                <img
                  src={photoPreview}
                  alt="Donor"
                  crossOrigin="anonymous"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = "none";
                  }}
                />
              </div>
            </div>
          )}
        </div>

        {/* Benefits - chevron badges */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            padding: "10px 28px 24px 28px",
            gap: 0,
            position: "relative",
            zIndex: 1,
          }}
        >
          <div style={{ width: 150, paddingTop: 8 }}>
            <p
              style={{
                margin: 0,
                color: "#dc3545",
                fontWeight: 800,
                fontSize: 16,
              }}
            >
              MEMBER <span style={{ color: "#1a1a1a" }}>BENEFITS</span>
            </p>
            <p
              style={{
                margin: "6px 0 0 0",
                fontSize: 12,
                color: "#444",
                fontWeight: 600,
              }}
            >
              Terms and
              <br />
              Conditions apply
            </p>
          </div>

          {[
            {
              label: "Lab Services",
              phone: "0337-7774511",
              color: "#0d6efd",
              note: "40% Saving on Lab Tests with home sampling option",
            },
            {
              label: "Blood Bank",
              phone: "0323-8443294",
              color: "#fd7e14",
              note: "Priority assistance in arranging Blood when required",
            },
            {
              label: "Pharmacy",
              phone: "0333-4388437",
              color: "#28a745",
              note: "10% Discount on medicines and healthcare products",
            },
          ].map((b, i) => (
            <div
              key={i}
              style={{
                flex: 1,
                position: "relative",
                marginLeft: i === 0 ? 0 : -12,
              }}
            >
              <div
                style={{
                  background: b.color,
                  color: "#fff",
                  padding: "8px 16px 8px 22px",
                  fontSize: 13,
                  fontWeight: 700,
                  clipPath:
                    "polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%, 10% 50%)",
                  whiteSpace: "nowrap",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                📞 {b.label}
                <br />
                {b.phone}
              </div>
              <div
                style={{
                  background: `${b.color}1a`,
                  borderTop: `2px solid ${b.color}`,
                  fontSize: 11,
                  color: "#444",
                  padding: "8px 14px",
                  textAlign: "center",
                  marginTop: 4,
                  fontWeight: 600,
                }}
              >
                {b.note}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default DonorCard;